import { render } from "./DemandNoticeModal.vue?vue&type=template&id=4917c50f&scoped=true"
import script from "./DemandNoticeModal.vue?vue&type=script&lang=js"
export * from "./DemandNoticeModal.vue?vue&type=script&lang=js"

import "./DemandNoticeModal.vue?vue&type=style&index=0&id=4917c50f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4917c50f"]])

export default __exports__